import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { App } from './app';
import { ApiError } from './lib/api';
import '@fontsource-variable/geist';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // 4xx is een antwoord, geen storing: niet opnieuw proberen.
      retry: (count, error) =>
        count < 2 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* Design-skill: toasts volle breedte op mobiel, boven de bottom-nav. */}
      <Toaster
        position="bottom-center"
        mobileOffset={{ bottom: 88 }}
        toastOptions={{
          classNames: {
            toast:
              '!font-sans !bg-popover !text-popover-foreground !border-border !rounded-lg !shadow-md',
            description: '!text-muted-foreground',
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
